import React from 'react';
import { Footer } from '../components';

export function FooterContainer() {
  return (
    <Footer>
      <Footer.Title>Questions? Contact us.</Footer.Title>
      <Footer.Break />
      <Footer.Row>
        <Footer.Column>
          <Footer.Link href="#">Audio and subtitles</Footer.Link>
          <Footer.Link href="#">Hurry</Footer.Link>
          <Footer.Link href="#">Confidentiality</Footer.Link>
          <Footer.Link href="#">Contact us</Footer.Link>
        </Footer.Column>

        <Footer.Column>
          <Footer.Link href="#">Audiodescription</Footer.Link>
          <Footer.Link href="#">Investor Relations</Footer.Link>
          <Footer.Link href="#">Legal information</Footer.Link>
        </Footer.Column>

        <Footer.Column>
          <Footer.Link href="#">Help center</Footer.Link>
          <Footer.Link href="#">Recruitment</Footer.Link>
          <Footer.Link href="#">Cookie Preferences</Footer.Link>
        </Footer.Column>

        <Footer.Column>
          <Footer.Link href="#">Media Centre</Footer.Link>
          <Footer.Link href="#">Gift cards</Footer.Link>
          <Footer.Link href="#">Legal Notices</Footer.Link>
        </Footer.Column>
      </Footer.Row>
      <Footer.Break />
      <Footer.Text>Mansflix</Footer.Text>
    </Footer>
  );
}
